import { render } from "./CallAttentionDetail.vue?vue&type=template&id=19e7ba5a"
import script from "./CallAttentionDetail.vue?vue&type=script&lang=js"
export * from "./CallAttentionDetail.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"

import exportComponent from "D:\\EME_MARKETING_AND_CONSULTING\\_Proyectos\\bookapps\\Apps Code\\web-admin-bookapps-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__